import styled from 'styled-components';
import DocsFilters from './DocsFilters';

export default styled(DocsFilters)`
  .docs-filters {
    background: var(--grey100);
    padding: 1.6rem;

    &__row {
      margin-bottom: 0.8rem;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
`;
